import './styles/tailwind.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { CONS } from '@pomofocus/core';
import { initializeApiClient } from '@pomofocus/shared-client';
import configureStore from './store/configureStore';
import App from './components/AppContainer';
import { ENV } from './constants';
import { WebTokenProvider } from './utils/webTokenProvider';
import { initializeSentry } from './utils/sentry';
// Initialize Sentry for error tracking
initializeSentry();
// Initialize API client with version
initializeApiClient(ENV.BASE_URL, new WebTokenProvider(), CONS.API_VERSION);
// redux
const store = configureStore();
const container = document.getElementById('target');
const root = createRoot(container);
root.render(React.createElement(GoogleOAuthProvider, { clientId: ENV.GAPI_CLIENT_ID },
    React.createElement(Provider, { store: store },
        React.createElement(App, null))));
if (module.hot) {
    module.hot.accept('./components/AppContainer', () => {
        root.render(React.createElement(GoogleOAuthProvider, { clientId: ENV.GAPI_CLIENT_ID },
            React.createElement(Provider, { store: store },
                React.createElement(App, null))));
    });
}
